import { gql } from '@apollo/client';
import LeadFragments from '../fragments/lead.fragments';

const UPDATE_LEAD = gql`
  mutation UpdateLead($params: LeadParams!) {
    updateLead(params: $params) {
      ...LeadFields
      ...LeadLoiFiles
      ...LeadOffers
      ...LeadFileAccessLevel
      ...LeadPrivateListingAccess
      ...LeadNotes
      ...LeadSellerNotes
      ...LeadUser
      ...LeadListing
      ...LeadMetrics
      ...LeadMeta
      ...LeadAnalyticsEvents
      ...LeadChannel
    }
  }

  ${LeadFragments.fields}
  ${LeadFragments.loiFiles}
  ${LeadFragments.offers}
  ${LeadFragments.fileAccessLevel}
  ${LeadFragments.privateListingAccess}
  ${LeadFragments.notes}
  ${LeadFragments.sellerNotes}
  ${LeadFragments.user}
  ${LeadFragments.listing}
  ${LeadFragments.metrics}
  ${LeadFragments.meta}
  ${LeadFragments.analyticsEvents}
  ${LeadFragments.channel}
`;

export default UPDATE_LEAD;
